import { ProductCarouselCard } from '../ProductCarouselCard';
import { ProductCarouselSlide } from '../product-carousel.types';

interface ProductCarouselMobileViewportProps {
  viewportRef: (node: HTMLElement | null) => void;
  mobileSlideGroups: ProductCarouselSlide[][];
}

export function ProductCarouselMobileViewport({ viewportRef, mobileSlideGroups }: ProductCarouselMobileViewportProps) {
  return (
    <div className="relative w-full md:hidden">
      <div className="overflow-hidden" ref={viewportRef}>
        {/* Embla track must be horizontal; each slide will contain a vertical stack of cards */}
        <div className="flex flex-row touch-pan-y -ml-4">
          {mobileSlideGroups.map((group, slideIdx) => (
            <div key={`mobile-slide-${slideIdx}`} className="pl-4 shrink-0 grow-0 basis-full w-full">
              <div className="flex flex-col gap-sm w-full">
                {group?.map((item, idx) => (
                  <ProductCarouselCard key={`mobile-card-${slideIdx}-${idx}`} {...item} />
                ))}
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}
